(() => {
  if (window.ehsIrCompareInstalled) return;
  window.ehsIrCompareInstalled = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ehs-compare]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#')) return;
    const anchor = document.getElementById(href.slice(1));
    if (!anchor) return;
    const region = anchor.closest('.ehs-ir');
    const id = link.dataset.ehsCompare;
    if (!region || !id) return;
    let target = null;
    region.querySelectorAll('[data-ehs-column]').forEach((cell) => {
      const selected = cell.dataset.ehsColumn === id;
      cell.classList.toggle('is-selected', selected);
      if (selected && cell.tagName === 'TH') target = cell;
    });
    if (target) {
      const scroller = region.querySelector('.ehs-ir__table-scroll');
      if (scroller) scroller.scrollLeft = Math.max(0, target.offsetLeft - 160);
    }
  });
})();

(() => {
  if (window.ehsIrRailInstalled) return;
  window.ehsIrRailInstalled = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ehs-slide]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (!rail) return;
    rail.scrollBy({left: Number(button.dataset.ehsSlide) * rail.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
})();
